export const noop = (): null => null;

export const skaCountryConfig = {
  'notino.cz': {
    locale: 'cz',
    partnerId: 'WrLfKJfKTV',
  },
  'notino.sk': {
    locale: 'sk',
    partnerId: 'NZoKUT127u',
  },
  'notino.it': {
    locale: 'it',
    partnerId: 'tC4ZmDdLCc',
  },
  'notino.pl': {
    locale: 'pl',
    partnerId: 'Vl04MGlEhq',
  },
  'notino.ro': {
    locale: 'ro',
    partnerId: 'LTFRAa90DW',
  },
};
